import { defineMessages } from "@/i18n";
import en from "./en";

export const panelsHeaderMessages = defineMessages("panels-header", en);
